import Placeholder from "./Placeholder";

const LocationItem = ({ location }) => {
  return (
    <li className="uberall-locations__item">
      <div className="uberall-locations__item-image">
        {location.url
          ? (
            <a href={location.url} target="_blank">
              {location.image
                ? <img src={location.image} alt={location.name} />
                : <Placeholder />
              }
            </a>
          )
          : (
            location.image
              ? <img src={location.image} alt={location.name} />
              : <Placeholder />
          )
        }
      </div>
      <div className="uberall-locations__item-content is-text">
        <h3 className="uberall-locations__item-name">

          {location.url
            ? <a href={location.url} target="_blank">{location.name}</a>
            : <span>{location.name}</span>
          }
        </h3>
        {(location.city || location.address) && (
          <p className="uberall-locations__item-address">
            {location.zip} {location.city}
            {location.city && location.address && <br />}
            {location.address}
          </p>
        )}
        <div className="uberall-locations__item-meta">
          <div className="uberall-locations__item-contact">
            {location.phone && (
              <a href={`tel:${location.phone}`} className="uberall-locations__item-phone uberall-location-icon phone">
                {location.phone}
              </a>
            )}
            {location.mail && (
              <a href={`mailto:${location.mail}`} className="uberall-locations__item-mail uberall-location-icon mail">
                {location.mail}
              </a>
            )}
          </div>
          <div className="uberall-locations__item-actions">
            {location.googleRouteUrl && (
              <a href={location.googleRouteUrl} className="btn btn--primary uberall-locations__item-btn uberall-locations__item-btn--route" target="_blank" rel="noopener noreferrer">
                <svg xmlns="http://www.w3.org/2000/svg" height="48px" viewBox="0 -960 960 960" width="48px" fill="currentColor"><path d="M360-160v-298q0-12.09 5-23.04Q370-492 378-500l240-240H491v-60h229v229h-60v-127L420-458v298h-60Z"/></svg>
                Route
              </a>
            )}
            {location.url && (
              <a href={location.url} className="btn btn--primary uberall-locations__item-btn uberall-locations__item-btn--details" target="_blank">
                Mehr Details
              </a>
            )}
          </div>
        </div>
      </div>
    </li>
  );
};
export default LocationItem;
